import React, { useCallback, useEffect, useState } from "react";
import SendMoneyService from "../services/send-money.service";
import profileIcon from "../assests/new-images/profile_new.png";
import { useTranslation } from "react-i18next";

export default function BeneficiaryDisplay({ beneDetails = {} }) {
  const [payeeImage, setPayeeImage] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    getPayeeImages(beneDetails);
  }, [beneDetails]);

  const getPayeeImages = useCallback(async (details) => {
    try {
      const req = {
        accNo: [details?.payeeAccountNo || details?.accountNo],
      };
      const response = await SendMoneyService.getPayeeImages(req);
      if (response.status === 200) {
        setPayeeImage(response.data["data"]["imagesList"][0]?.imageData);
      }
    } catch (error) { }
  }, []);

  return (
    <div className="d-flex">
      <img
        src={payeeImage ? payeeImage : profileIcon}
        alt="account"
        height={45}
        width={45}
      />
      <div style={{ marginLeft: 11 }}>
        <span>
          {t("common.destination_account", {
            defaultValue: "Destination Account",
          })}
        </span>{" "}
        <br />
        <label>
          {beneDetails?.beneName ||
            beneDetails?.payeeNickName ||
            beneDetails?.accountName ||
            beneDetails?.destAccName}
        </label>
        <h6>
          {beneDetails?.payeeAccountNo ||
            beneDetails?.accountNo ||
            beneDetails?.destAccount}
        </h6>
        <span className="primary-color">
          {beneDetails?.beneCurrency}
        </span>
      </div>
    </div>
  );
}
